import { calculatePercentThruBudget } from "./budgetUtils";
import { calculatePercentThruMonth } from "./calendarUtils";
  
  export const displayColor = (expenses, budget) => {
    if (calculatePercentThruBudget(expenses, budget) > 100) {
      return "bg-red-600";
    } else if (calculatePercentThruBudget(expenses, budget) > calculatePercentThruMonth()) {
      return "bg-yellow-400";
    } else {
      return "bg-green-600";
    }
  };
  
  export const localizeDates = (expenseArray) => {
    for (var i = 0; i < expenseArray.length; i++) {
      expenseArray[i].date = new Date(expenseArray[i].date).toLocaleDateString(
        "en-US",
        { timeZone: "UTC" }
      );
    }
    return expenseArray;
  };
  